<template>
    <div v-if="simuladorStatus != 2">
        <div class="center" v-if="simuladorStatus == 1">
            <button class="btn" @click="marcarProduto(0)" style="width: 85%" :class="[produtos.includes(0) || bloqueados.includes(0) ? 'btn-default' : 'text-default white']">
                SIMULAR
            </button>
        </div>

        <div class="scroll">
            <div v-for="(item, index) in produtosItens" :key="index">
                <div class="card product gradient-shadow bg-primary z-depth-3">
                    <div class="padding-3 center-align">
                        <i class="material-icons white-text card-icon">{{ item.produto_icone}}</i>
                        <button
                            class="btn-flat waves-effect icon-absolute btn-floating btn-transparent right product-detail"
                            v-tooltip.top="'Detalhes'" @click="abreModalDetalhe(item)">
                            <i class="material-icons product-detail-icon">info_outline</i>
                        </button>
                        <h6 class="center-align white-text uppercase">{{ item.produto_nome }}</h6>
                        <div class="border-non mt-5 center-align">
                            <button
                                :disabled="bloqueados.includes(item.produto_id)"
                                class="btn white waves-effect waves-light btn-small text-default"
                                :class="{active: produtoSelecionado(item.produto_id), blocked: bloqueados.includes(item.produto_id)}"
                                @click="marcarProduto(item.produto_id)">

                                <span v-if="bloqueados.includes(item.produto_id)">Em andamento</span>
                                <span v-else-if="produtoSelecionado(item.produto_id)">Selecionado</span>
                                <span v-else>Selecionar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Auth from '@/store/auth';
import api from "@/helpers/api"
export default {

    props: ['value', 'bloqueados'],
    data() {
        return {
            simuladorStatus: 2,
            produtosItens: [],
            produtos: [],
        }
    },

    async created() {

        this.simuladorStatus = await Auth.statusSimulador();

        const {data: {result: {data: produtos}}} = await api.get('produto')

        this.produtosItens = produtos;
    },

    methods: {
        produtoSelecionado(id) {
            return this.produtos.includes(id) || this.bloqueados.includes(id);
        },
        marcarProduto(id) {

            if (this.bloqueados.includes(id)) return;

            if (this.produtos.includes(id)) {
                this.produtos.splice(this.produtos.indexOf(id), 1);
            } else {
                this.produtos.push(id);
            }


            this.$emit('input', this.produtos)
        },
        checkCor(id) {
            if (this.produtos.indexOf(id) !== -1) {
                return 'blue';
            } else {
                return 'red';
            }
        },
    },

    watch:
    {
        value: {
            deep: true,
            immediate: true,
            handler(produtos) {
                this.produtos = produtos;
            }
        }
    }
}
</script>

<style lang="scss">

.gradient-45deg-green-light-blue {
    background: #2f687c;
}

.gradient-45deg-green-light-blue.gradient-shadow {
    box-shadow: 0 6px 20px 0 rgba(79, 195, 247, 0.5);
}

.center, .center-align {
  text-align: center;
}

.product .active {
    background: var(--color-primary) !important;
    color: #fff !important;
}

.product .blocked {
    background-color: transparent !important;
    color: #fff;
}

.icon-absolute {
    position: absolute;
    right: 10px;
    top: 5px
}

.scroll {
    overflow-x: hidden;
    overflow-y: scroll;
    height: 813px;
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ListaProdutos.vue